export enum ApplicationLanguages {
  ENGLISH=1,
  FRENCH=2
}


